/**
 * Registro de diagnóstico para las llamadas a Supabase.
 *
 * Imprime en la consola del navegador el paso, el payload enviado y el error
 * completo devuelto por Postgres (mensaje, código, detalle y pista). Nunca
 * imprime claves ni cabeceras de autenticación: solo datos de negocio.
 */
const PREFIX = '[AVA]'

/** Estructura del error que devuelve supabase-js. */
export interface SupabaseErrorLike {
  message?: string
  code?: string
  details?: string
  hint?: string
}

export function logRequest(step: string, payload: unknown): void {
  // eslint-disable-next-line no-console
  console.info(`${PREFIX} ${step} — payload enviado:`, payload)
}

export function logSuccess(step: string, result: unknown): void {
  // eslint-disable-next-line no-console
  console.info(`${PREFIX} ${step} — respuesta correcta:`, result)
}

export function logFailure(
  step: string,
  error: SupabaseErrorLike | null | undefined,
  payload?: unknown,
): void {
  // eslint-disable-next-line no-console
  console.error(`${PREFIX} ${step} — ERROR de Supabase`, {
    message: error?.message ?? 'sin mensaje',
    code: error?.code ?? 'sin código',
    details: error?.details ?? 'sin detalle',
    hint: error?.hint ?? 'sin pista',
    payload,
  })
}

/** Mensaje legible que incluye código y detalle cuando existen. */
export function describeError(error: SupabaseErrorLike | null | undefined): string {
  if (!error) return 'Error desconocido.'
  const parts = [error.message || 'Error desconocido.']
  if (error.code) parts.push(`(código ${error.code})`)
  if (error.details) parts.push(`· ${error.details}`)
  if (error.hint) parts.push(`· ${error.hint}`)
  return parts.join(' ')
}

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

/** Comprueba que un identificador existe y es un UUID válido. */
export function isUuid(value: unknown): value is string {
  return typeof value === 'string' && UUID_RE.test(value)
}
